import faAlignLeft from '@fortawesome/fontawesome-pro-light/faAlignLeft';
import faChartBar from '@fortawesome/fontawesome-pro-light/faChartBar';
import faChartLine from '@fortawesome/fontawesome-pro-light/faChartLine';
import faCog from '@fortawesome/fontawesome-pro-light/faCog';
import faHome from '@fortawesome/fontawesome-pro-light/faHome';
import faListUl from '@fortawesome/fontawesome-pro-light/faListUl';
import faListAlt from '@fortawesome/fontawesome-pro-light/faListAlt';
import faPlus from '@fortawesome/fontawesome-pro-light/faPlus';
import faQuestionCircle from '@fortawesome/fontawesome-pro-light/faQuestionCircle';
import faSearch from '@fortawesome/fontawesome-pro-light/faSearch';
import faTh from '@fortawesome/fontawesome-pro-light/faTh';
import faUserMd from '@fortawesome/fontawesome-pro-light/faUserMd';
import { List, Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import UserDropdownButton from '../../../../buttons/UserDropdownButton';
import CreateIcon from './CreateIcon';
import GoToIcon from './GoToIcon';
import NavIcon from './NavIcon';
import NotificationIcon from './NotificationIcon';
import ProductPicker from './ProductPicker';
import SearchIcon from './SearchIcon';
import SwitchProjectsIcon from './SwitchProjectsIcon';

import { connect } from 'react-redux';
import immutableCreatorSelector from '../../../../../selectors/immutableCreatorSelector';

import CurrentUserContext from '../../../../../contexts/CurrentUser';
import { faSitemap } from '@fortawesome/fontawesome-pro-light';

class IconNavList extends Component {
  static propTypes = {
    userMode: PropTypes.string,
    project: PropTypes.instanceOf(Map),
    taskTypeId: PropTypes.string,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    projectId: PropTypes.string,
    flatTaskDsmId: PropTypes.string,
    ppcGraphId: PropTypes.string,
    rootCauseGraphId: PropTypes.string,
    isAccountAdmin: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.buildUrlMap();

    const currentTab = Object.keys(this.urlMap).find(url => {
      if (url === 'Settings') {
        return props.location.pathname.indexOf('settings') > -1;
      } else {
        return this.urlMap[url].url === props.location.pathname;
      }
    });

    this.state = {
      currentTab,
      currentProjectId: props.projectId,
    };
  }

  iconMap = {
    'Product Home': faHome,
    'Planner Dashboard': faHome,
    'Issues Dashboard': faHome,
    Plus: faPlus,
    Search: faSearch,
    WBS: faSitemap,
    Tasks: faListUl,
    Gantt: faAlignLeft,
    List: faListAlt,
    DSM: faTh,
    'PPC Graph': faChartLine,
    'Root Cause Graph': faChartBar,
    'Task Doctor': faUserMd,
    Settings: faCog,
    Help: faQuestionCircle,
  };

  productMap = {
    'Planner Dashboard': 'planner',
    'Issues Dashboard': 'issues',
    Tasks: 'planner',
    Gantt: 'planner',
    List: 'issues',
    DSM: 'planner',
    WBS: 'planner',
    'PPC Graph': 'planner',
    'Root Cause Graph': 'planner',
    'Task Doctor': 'planner',
  };

  urlMap = {};

  buildUrlMap = () => {
    const {
      projectId,
      taskTypeId,
      ppcGraphId,
      rootCauseGraphId,
      userMode,
      location,
      isAccountAdmin,
    } = this.props;

    const adminMode = userMode === 'admin';
    const projectPath = `/project/${projectId}`;
    const taskListUrl = taskTypeId
      ? `${projectPath}/element-type/${taskTypeId}/elements${location.hash}`
      : null;

    this.urlMap['Project Home'] = { url: projectPath };
    this.urlMap['Issues Dashboard'] = { url: `${projectPath}/issues` };
    this.urlMap['Planner Dashboard'] = { url: `${projectPath}/planner` };
    this.urlMap.Tasks = { url: taskListUrl };
    this.urlMap.Gantt = { url: `${projectPath}/gantt${location.hash}` };
    this.urlMap.DSM = { url: `${projectPath}/dsm${location.hash}` };
    this.urlMap.WBS = { url: `${projectPath}/wbs` };
    this.urlMap.List = { url: `${projectPath}/list${location.hash}` };
    this.urlMap['PPC Graph'] = { url: `${projectPath}/view/${ppcGraphId}` };
    this.urlMap['Root Cause Graph'] = {
      url: `${projectPath}/view/${rootCauseGraphId}`,
    };
    this.urlMap['Task Doctor'] = { url: `${projectPath}/task-doctor` };
    if (adminMode || isAccountAdmin) {
      this.urlMap.Settings = { url: `${projectPath}/settings/project` };
    }
    this.urlMap.Help = {
      url: 'https://lattixsight.com/help/',
    };
  };

  componentDidUpdate = () => {
    // This is not correct but is left here for now.
    // Since the urlMap is not in state the fresh values are not pulled in
    // when building of the menu is triggered.
    this.buildUrlMap();
  };

  componentWillReceiveProps = nextProps => {
    const newLocation = nextProps.location.pathname;

    if (this.props.location.pathname !== newLocation) {
      const currentTab = Object.keys(this.urlMap).find(url => {
        if (url === 'Settings') {
          return newLocation.indexOf('settings') > -1;
        } else {
          return this.urlMap[url].url === newLocation;
        }
      });

      this.setState({
        currentTab,
      });
    }
  };

  selectProductIconsList = product => {
    switch (product) {
      case 'issues':
        return ['List'];
      default:
        return [
          'WBS',
          'Tasks',
          'DSM',
          'Gantt',
          'PPC Graph',
          'Root Cause Graph',
          'Task Doctor',
        ];
    }
  };

  buildNavList = product => {
    const { currentTab } = this.state;
    this.buildUrlMap(); // Enabling the refresh of the UrlMap
    const productIconList = this.selectProductIconsList(product);

    return productIconList.concat(['Settings', 'Help']).reduce((prev, link) => {
      return prev.push(
        <NavIcon
          title={link}
          key={link}
          icon={this.iconMap[link]}
          product={this.productMap[currentTab]}
          selected={link === currentTab}
          linkTarget={this.urlMap[link] ? this.urlMap[link].url : ''}
        />,
      );
    }, List());
  };

  resetState = () => {
    this.buildUrlMap();
    const currentTab = Object.keys(this.urlMap).find(
      url => this.urlMap[url].url === this.props.location.pathname,
    );

    this.setState({
      currentTab,
      currentProjectId: this.props.projectId,
    });
  };

  buildHomeNavIcon = (title, currentTab) => {
    return (
      <NavIcon
        title={title}
        key={title}
        icon={faHome}
        product={this.productMap[currentTab]}
        selected={currentTab === title}
        linkTarget={this.urlMap[title].url}
      />
    );
  };

  determineHomeNavIcon = (product, currentTab) => {
    switch (product) {
      case 'issues':
        return this.buildHomeNavIcon('Issues Dashboard', currentTab);
      default:
        return this.buildHomeNavIcon('Planner Dashboard', currentTab);
    }
  };

  determineProduct = () => {
    const { currentTab } = this.state;

    // TODO: NEED AUTH ON EACH OF THESE TO DETERMINE IF OWNED
    if (this.productMap[currentTab] === 'issues') {
      return 'issues';
    } else if (this.productMap[currentTab] === 'planner') {
      return 'planner';
    } else if (sessionStorage.getItem('product')) {
      return sessionStorage.getItem('product');
    } else {
      // TODO: Here we need to pull in user data to determine which product they own and default to the correct product
      return 'planner';
    }
  };

  render() {
    const { dispatch, currentUser, projectId } = this.props;
    const { currentTab } = this.state;
    if (this.state.currentProjectId !== this.props.projectId) this.resetState();

    const product = this.determineProduct();

    return (
      <CurrentUserContext.Provider product={{ product }}>
        <div
          className={
            product === 'planner'
              ? 'side-nav side-nav-background-planner'
              : 'side-nav side-nav-background-issues'
          }
        >
          <div>
            <NavIcon
              title={'Switch Products'}
              key={'Switch Products'}
              overrideVisible={true}
            >
              <ProductPicker currentProjectId={projectId} product={product} />
            </NavIcon>
            {this.determineHomeNavIcon(product, currentTab)}
            <CreateIcon />
            <SearchIcon currentProjectId={this.props.projectId} />
            {/* <NavIcon title={'Search'} key={'Search'} icon={faSearch}>
              <SearchIcon currentProjectId={this.props.projectId} />
            </NavIcon> */}
            {this.buildNavList(product)}
          </div>
          <div>
            <SwitchProjectsIcon />
            <NavIcon title={'Go To'} key={'Go To'}>
              <GoToIcon />
            </NavIcon>
            <NavIcon title={'Notifications'} key={'Notifications'}>
              <NotificationIcon />
            </NavIcon>
            <UserDropdownButton dispatch={dispatch} user={currentUser} />
          </div>
        </div>
      </CurrentUserContext.Provider>
    );
  }
}

export default IconNavList;



// WEBPACK FOOTER //
// ./src/components/toolbars/IconNavList/industry/construction/IconNavList.js